import { Widget } from "fmko-ts-common";
import { CertTestCaseVO, CertTestVO, TestCaseStatus } from "./RestTypes";
import CertTestService from "./CertTestService";
import CertTestAdminApp from "./CertTestAdminApp";

export default class StartStopTestCaseWidget extends Widget {
    testCase: CertTestCaseVO;
    constructor(test: CertTestVO, testCase: CertTestCaseVO) {
        super();

        this.testCase = testCase;

        let action = "?";

        let button = <HTMLButtonElement>document.createElement("button");

        switch (testCase.status) {
            case TestCaseStatus.READY:
                button.innerHTML = '<span class="glyphicon glyphicon-play"></span> Start';
                button.className = "btn btn-success";
                action = "start";
                break;
            case TestCaseStatus.STARTED:
                button.innerHTML = '<span class="glyphicon glyphicon-stop"></span> Stop';
                button.className = "btn btn-danger";
                action = "stop";
                break;
            case TestCaseStatus.EXPIRED:
                button.innerHTML = '<span class="glyphicon glyphicon-refresh"></span> Genstart';
                button.className = "btn btn-success";
                action = "start";
                break;
            case TestCaseStatus.FINISHED:
                button.innerHTML = '<span class="glyphicon glyphicon-refresh"></span> Genstart';
                button.className = "btn btn-success";
                action = "start";
                break;
        }

        button.addEventListener("click", (ev: MouseEvent) => {
            CertTestService.getInstance().updateTestCaseState(test.name, testCase.testID, action).then((tc) => {
                CertTestAdminApp.certTestPanel.reload().then(() => {
                    CertTestAdminApp.certTestPanel.focusTestCase(this.testCase.testID);
                });
            }).catch(err => CertTestAdminApp.alert("Opdatér fejlede", err.message));

        });
        this.element = button;


    }
}
